import { render, staticRenderFns } from "./ExportJson.vue?vue&type=template&id=cc8ca630"
import script from "./ExportJson.vue?vue&type=script&lang=ts"
export * from "./ExportJson.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc8ca630')) {
      api.createRecord('cc8ca630', component.options)
    } else {
      api.reload('cc8ca630', component.options)
    }
    module.hot.accept("./ExportJson.vue?vue&type=template&id=cc8ca630", function () {
      api.rerender('cc8ca630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/ExportJson.vue"
export default component.exports